import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Set from '@babel/runtime-corejs3/core-js-stable/set';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';

// cheap lodash replacements
function memoize(fn) {
  var result = null;
  var memoized = function memoized() {
    if (result == null) {
      result = fn();
    }
    return result;
  };
  return memoized;
}
/**
 * drop-in replacement for _.without
 */
function without(items, item) {
  return _filterInstanceProperty(items).call(items, function (i) {
    return i !== item;
  });
}
function union(itemsA, itemsB) {
  var set = new _Set();
  var insertItem = function insertItem(item) {
    return set.add(item);
  };
  _forEachInstanceProperty(itemsA).call(itemsA, insertItem);
  _forEachInstanceProperty(itemsB).call(itemsB, insertItem);
  var result = [];
  _forEachInstanceProperty(set).call(set, function (key) {
    return result.push(key);
  });
  return result;
}

export { memoize, union, without };
